import {Component, Input} from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-user-avatar',
    imports: [CommonModule],
    templateUrl: './user-avatar.component.html',
    styleUrls: ['./user-avatar.component.scss'],
    standalone: true
})
export class UserAvatarComponent {
    @Input() name: string = '';
    @Input() backGroundColor: string = '';


    // Get the initial letter of the name
    get initial(): string {
        return this.name ? this.name.charAt(0).toUpperCase() : '';
    }

    // Get a color based on the initial
    get backgroundColor(): string {
        return this.backGroundColor ? this.backGroundColor : this.getRandomColor();
    }

    // Generate a random color
    private getRandomColor(): string {
        return '#' + (Math.random() * 0xFFFFFF << 0).toString(16);
    }
}
